import React from 'react';
import { Divider, Grid, Typography, useTheme } from '@material-ui/core';
import cardAccountDetailsOutline from '@iconify-icons/mdi/card-account-details-outline';
import { useTranslation } from 'react-i18next';
import PatientDetailItem from './PatientDetailItem';

export default function PatientSummaryTooltip(props) {
  const { t } = useTranslation();
  const theme = useTheme();

  const { pat_name, birth, device, operator, referring, screening, patient_id, date, institution } =
    props.results;

  const today = new Date();
  const birthDate = new Date(birth);
  const getAge = () => {
    let age = today.getFullYear() - birthDate.getFullYear();
    let m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  };
  return (
    <div>
      <Typography
        style={{
          letterSpacing: '0.1rem',
          color: theme.palette.texts.primary,
          fontSize: theme.fonts.responsiveBig,
          fontWeight: 'bold',
        }}>
        {pat_name}
      </Typography>

      <Divider style={{ margin: '3% 0' }} />

      <div
        style={{
          marginBottom: '6px',
          padding: '6px',
          borderRadius: '5px',
        }}>
        <PatientDetailItem title={t('ResultView.dob')} result={birth.slice(0, 10)} />

        <PatientDetailItem title={t('ResultView.age')} result={getAge()} />

        <PatientDetailItem title={t('ResultView.date')} result={date?.slice(0, 10)} />

        <PatientDetailItem title={t('ResultView.pat_id')} result={patient_id} />

        <PatientDetailItem
          title={t('ResultView.purpose')}
          result={screening ? 'Screening' : t('ResultView.diagnostic')}
        />

        <PatientDetailItem title={t('ResultView.device')} result={device} />

        <PatientDetailItem
          title={t('ResultView.operator')}
          result={operator === 'Unknown Operator' ? 'unknown' : operator}
        />

        <PatientDetailItem title={t('ResultView.institution')} result={institution || 'unknown'} />

        <PatientDetailItem title={t('ResultView.referring')} result={referring} />
      </div>
    </div>
  );
}
